import { render } from "./PajakModal_c.vue?vue&type=template&id=a87c8eb2&scoped=true"
import script from "./PajakModal_c.vue?vue&type=script&lang=js"
export * from "./PajakModal_c.vue?vue&type=script&lang=js"

import "./PajakModal_c.vue?vue&type=style&index=0&id=a87c8eb2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a87c8eb2"

export default script